module.exports = __webpack_public_path__ + "img/deco-16.3ea2b102.png";